import React from 'react'

const PhoneOutlineIcon = () => {
	return(
		<svg xmlns="http://www.w3.org/2000/svg" width="23.346" height="23.346" viewBox="0 0 23.346 23.346"><path d="M14.172 10.275l-1.958-1.954a1.3 1.3 0 0 0-2.168.488 1.333 1.333 0 0 1-1.538.837 6.031 6.031 0 0 1-3.636-3.628 1.264 1.264 0 0 1 .839-1.535 1.3 1.3 0 0 0 .489-2.163l-1.957-1.954a1.4 1.4 0 0 0-1.888 0l-1.329 1.326c-1.326 1.396-1.451 6.571 1.835 9.85s8.584 3.338 9.982 1.942l1.329-1.326a1.391 1.391 0 0 0 0-1.883z" transform="matrix(.707 .707 -.707 .707 11.477 1.404)" stroke="#fff" fill="none"/></svg>
	)
}

export default PhoneOutlineIcon